var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"ondragstart":"return false","ondrop":"return false"}},[_c('SnackBar'),_c('router-view'),_c('v-fab-transition',[(_vm.showToTop)?_c('v-btn',{attrs:{"color":"accent","fixed":"","right":"","bottom":"","small":"","fab":""},on:{"click":_vm.onToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up-bold")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }